// extracted by mini-css-extract-plugin
export var container = "client-section-module--container--iqj-s";
export var wrapper = "client-section-module--wrapper--2jjLD";
export var clientBoxes = "client-section-module--client-boxes--MDliz";